import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import React from "react";
import Typography from "@mui/material/Typography";

interface ReportItemProps {
  name: string;
  amount: string;
}

const ReportItem: React.FC<ReportItemProps> = ({ name, amount }) => {
  return (
    <ListItem
      sx={{
        paddingBottom: "20px",
      }}
    >
      <Box
        sx={{
          borderRadius: "20px",
          backgroundColor: "rgba(0, 43, 107, 0.20)",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50%",
        }}
      >
        <Typography
          variant="h6"
          fontFamily="Lato"
          fontSize="16px"
          fontStyle="normal"
          fontWeight={600}
          lineHeight="normal"
        >
          {name}
        </Typography>

        <Typography
          variant="h6"
          fontFamily="Lato"
          fontSize="16px"
          fontStyle="normal"
          fontWeight={600}
          lineHeight="normal"
        >
          {amount}
        </Typography>
      </Box>
    </ListItem>
  );
};

export default ReportItem;
